/**
 * 発行フォーム専用の入力正規化（data 属性駆動。user-admin spec.md「発行フォームの入力正規化」/
 * 05_ui.md §3.3）
 *
 * マークアップ規約:
 *   <input data-lms-normalize="name">
 *   <input data-lms-normalize="email">
 *
 * ユーザー一覧の編集モーダルの入力欄には付けない（正規化を適用しないため）。
 */

const FULLWIDTH_OFFSET = 0xfee0;
const HIRAGANA_VOWELS: Record<string, string> = {
  あ: "a",
  い: "i",
  う: "u",
  え: "e",
  お: "o",
};
const EMAIL_ALLOWED = /^[A-Za-z0-9@._+-]*$/;

function toHalfWidthAlnum(char: string): string {
  const code = char.codePointAt(0);
  if (code === undefined) return char;
  if ((code >= 0xff21 && code <= 0xff3a) || (code >= 0xff41 && code <= 0xff5a) || (code >= 0xff10 && code <= 0xff19)) {
    return String.fromCodePoint(code - FULLWIDTH_OFFSET);
  }
  return char;
}

function normalizeNameValue(value: string): string {
  return value.replaceAll("　", " ");
}

function normalizeEmailValue(value: string): string {
  let result = "";
  for (const char of value) {
    const halfWidth = toHalfWidthAlnum(char);
    const converted = halfWidth !== char ? halfWidth : (HIRAGANA_VOWELS[char] ?? char);
    result += converted;
  }
  return Array.from(result)
    .filter((c) => EMAIL_ALLOWED.test(c))
    .join("");
}

function applyNormalization(
  input: HTMLInputElement,
  transform: (value: string) => string,
): void {
  const before = input.value;
  const after = transform(before);
  if (before === after) return;

  const selectionStart = input.selectionStart ?? after.length;
  // 変換前後で文字数が変わらない置換のみを想定するため、除去された文字数を差し引いてカーソル位置を復元する
  const removed = before.length - after.length;
  input.value = after;
  const newPos = Math.max(0, selectionStart - Math.max(removed, 0));
  input.setSelectionRange(newPos, newPos);
}

export function initNormalize(scope: ParentNode = document): void {
  scope.querySelectorAll<HTMLInputElement>("[data-lms-normalize]").forEach((input) => {
    if (input.dataset["lmsNormalizeReady"] === "1") return;
    input.dataset["lmsNormalizeReady"] = "1";

    const kind = input.dataset["lmsNormalize"];
    const transform = kind === "email" ? normalizeEmailValue : normalizeNameValue;

    input.addEventListener("input", () => applyNormalization(input, transform));
  });
}
